import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
axios.defaults.baseURL = process.env.REACT_APP_API_URL;

const getAbhaUserDetailsPayload = (payload) => {
  const list = payload?.result?.list;
  const source = Array.isArray(list) ? list[0] : list || payload?.result || payload;
  const details =
    source?.profile ||
    source?.userDetails ||
    source?.abhaProfile ||
    source?.ABHAProfile ||
    source?.account ||
    source?.patient ||
    source?.details ||
    source;

  if (!details || Array.isArray(details)) return null;

  return {
    ...details,
    ABHANumber:
      details?.ABHANumber ||
      details?.abhaNumber ||
      details?.abha_number ||
      details?.healthIdNumber ||
      source?.ABHANumber ||
      source?.abhaNumber ||
      "",
    abhaAddress:
      details?.preferredAbhaAddress ||
      details?.abhaAddress ||
      details?.ABHAAddress ||
      details?.phrAddress ||
      details?.healthId ||
      source?.preferredAbhaAddress ||
      source?.abhaAddress ||
      "",
    mobile:
      details?.mobile ||
      details?.mobileNumber ||
      details?.phone ||
      source?.mobile ||
      source?.mobileNumber ||
      "",
  };
};

const getScanAndShareUserDetailsPayload = (payload) => {
  const list = payload?.result?.list;
  const source = Array.isArray(list) ? list[0] : list || payload?.result || payload;
  const details =
    source?.sharedProfile ||
    source?.profile ||
    source?.patient ||
    source?.userDetails;

  if (!details || Array.isArray(details)) return null;

  return {
    ...details,
    ABHANumber:
      details?.ABHANumber ||
      details?.abhaNumber ||
      details?.healthIdNumber ||
      "",
    abhaAddress:
      details?.abhaAddress ||
      details?.preferredAbhaAddress ||
      details?.phrAddress ||
      details?.healthId ||
      "",
    mobile:
      details?.mobile ||
      details?.phone ||
      details?.mobileNumber ||
      details?.rawMobile ||
      "",
  };
};

export const generateAadhaarOtp = createAsyncThunk(
  "abhaDetails/generateAadhaarOtp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "abhaDetails/generateAadhaarOtp",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const verifyAadharOtp = createAsyncThunk(
  "abhaDetails/verifyAadharOtp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("abhaDetails/verifyAadharOtp", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const getUserDetails = createAsyncThunk(
  "abhaDetails/getUserDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("abhaDetails/getUserDetails", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const genetateMobileOtp = createAsyncThunk(
  "abhaDetails/genetateMobileOtp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("abhaDetails/genetateMobileOtp", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const verifyMobileOtp = createAsyncThunk(
  "abhaDetails/verifyMobileOtp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("abhaDetails/verifyMobileOtp", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getUserByNumber = createAsyncThunk(
  "abhaDetails/getUserByNumber",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("abhaDetails/getUserByNumber", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const verifyGetByNumber = createAsyncThunk(
  "abhaDetails/verifyGetByNumber",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("abhaDetails/verifyGetByNumber", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const verifyGetByNumberUser = createAsyncThunk(
  "abhaDetails/verifyGetByNumberUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "abhaDetails/verifyGetByNumberUser",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getAbhaAddressSuggestion = createAsyncThunk(
  "abhaDetails/getAbhaAddressSuggestion",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "abhaDetails/getAbhaAddressSuggestion",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const setAbhaAddress = createAsyncThunk(
  "abhaDetails/setAbhaAddress",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("abhaDetails/setAbhaAddress", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getUserByAadhar = createAsyncThunk(
  "abhaDetails/getUserByAadhar",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("abhaDetails/getUserByAadhar", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const verifyGetByAadhar = createAsyncThunk(
  "abhaDetails/verifyGetByAadhar",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("abhaDetails/verifyGetByAadhar", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getAbhaUserByAbhaNumber = createAsyncThunk(
  "abhaDetails/getAbhaUserByAbhaNumber",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "abhaDetails/getAbhaUserByAbhaNumber",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const verifyGetByAbhaNumber = createAsyncThunk(
  "abhaDetails/verifyGetByAbhaNumber",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "abhaDetails/verifyGetByAbhaNumber",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getAbhaUserByAbhaAddress = createAsyncThunk(
  "abhaDetails/getAbhaUserByAbhaAddress",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "abhaDetails/getAbhaUserByAbhaAddress",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const verifyGetByAbhaAddress = createAsyncThunk(
  "abhaDetails/verifyGetByAbhaAddress",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "abhaDetails/verifyGetByAbhaAddress",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const abhaAddressUserDetails = createAsyncThunk(
  "abhaDetails/abhaAddressUserDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "abhaDetails/abhaAddressUserDetails",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const downloadAbhaCard = createAsyncThunk(
  "abhaDetails/downloadAbhaCard",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("abhaDetails/downloadAbhaCard", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const generateScanAndShareQr = createAsyncThunk(
  "abhaDetails/generateScanAndShareQr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "abhaDetails/generateScanAndShareQr",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getScanAndShareStatus = createAsyncThunk(
  "abhaDetails/getScanAndShareStatus",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "abhaDetails/getScanAndShareStatus",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getScanAndShareUserDetails = createAsyncThunk(
  "abhaDetails/getScanAndShareUserDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "abhaDetails/getScanAndShareUserDetails",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const findAbhaByMobile = createAsyncThunk(
  "abhaDetails/findAbhaByMobile",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("abhaDetails/findAbhaByMobile", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const requestFindAbhaOtp = createAsyncThunk(
  "abhaDetails/requestFindAbhaOtp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("abhaDetails/requestFindAbhaOtp", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const verifyFindAbhaOtp = createAsyncThunk(
  "abhaDetails/verifyFindAbhaOtp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("abhaDetails/verifyFindAbhaOtp", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const AbhaRegistration = createSlice({
  initialState: {
    publicKey: null,
    accessToken: null,
    aadhaarOtp: null,
    userDetails: null,
    scanAndShareQr: null,
    scanAndShareStatus: null,
    findAbhaSearchResult: null,
    loading: false,
    error: null,
    success: null,
    adharOtpGenerateMsg: null,
  },
  name: "abhaDetails",
  reducers: {
    resetState: (state) => {
      state.publicKey = null;
      state.accessToken = null;
      state.aadhaarOtp = null;
      state.loading = false;
      state.error = null;
      state.success = null;
    },
    setFindAbhaUserDetails: (state, action) => {
      state.userDetails = action.payload || null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase("CLEAR_USER_DETAILS", (state) => {
        state.userDetails = null;
      })
      .addCase(generateAadhaarOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(generateAadhaarOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.aadhaarOtp = action.payload;
        state.success = true;
        state.error = null;
        state.adharOtpGenerateMsg =
          action.payload.result.list.message || "OTP sent successfully";
      })
      .addCase(generateAadhaarOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
        state.aadhaarOtp = null;
      })
      .addCase(verifyAadharOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyAadharOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(verifyAadharOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getUserDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetails = null;
        state.userDetails = action.payload?.result?.list || null;
        state.success = true;
        state.error = null;
      })
      .addCase(getUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
        state.userDetails = null;
      })
      .addCase(genetateMobileOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(genetateMobileOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(genetateMobileOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(verifyMobileOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyMobileOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(verifyMobileOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getUserByNumber.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserByNumber.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(getUserByNumber.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(verifyGetByNumber.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyGetByNumber.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(verifyGetByNumber.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(verifyGetByNumberUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyGetByNumberUser.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(verifyGetByNumberUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getAbhaAddressSuggestion.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAbhaAddressSuggestion.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(getAbhaAddressSuggestion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(setAbhaAddress.pending, (state) => {
        state.loading = true;
      })
      .addCase(setAbhaAddress.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(setAbhaAddress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getUserByAadhar.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserByAadhar.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(getUserByAadhar.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(verifyGetByAadhar.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyGetByAadhar.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(verifyGetByAadhar.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getAbhaUserByAbhaNumber.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAbhaUserByAbhaNumber.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(getAbhaUserByAbhaNumber.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(verifyGetByAbhaNumber.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyGetByAbhaNumber.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(verifyGetByAbhaNumber.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getAbhaUserByAbhaAddress.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAbhaUserByAbhaAddress.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(getAbhaUserByAbhaAddress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(verifyGetByAbhaAddress.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyGetByAbhaAddress.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(verifyGetByAbhaAddress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(abhaAddressUserDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(abhaAddressUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetails = null;
        state.userDetails = action.payload?.result?.list || null;
        state.success = true;
        state.error = null;
      })
      .addCase(abhaAddressUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(downloadAbhaCard.pending, (state) => {
        state.loading = true;
      })
      .addCase(downloadAbhaCard.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(downloadAbhaCard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(generateScanAndShareQr.pending, (state) => {
        state.loading = true;
        state.scanAndShareQr = null;
      })
      .addCase(generateScanAndShareQr.fulfilled, (state, action) => {
        state.loading = false;
        state.scanAndShareQr = action.payload?.result?.list || action.payload;
        state.success = true;
        state.error = null;
      })
      .addCase(generateScanAndShareQr.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getScanAndShareStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(getScanAndShareStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.scanAndShareStatus = action.payload?.result?.list || action.payload;
        state.success = true;
        state.error = null;
      })
      .addCase(getScanAndShareStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getScanAndShareUserDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getScanAndShareUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetails = getScanAndShareUserDetailsPayload(action.payload);
        state.success = true;
        state.error = null;
      })
      .addCase(getScanAndShareUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(findAbhaByMobile.pending, (state) => {
        state.loading = true;
        state.findAbhaSearchResult = null;
      })
      .addCase(findAbhaByMobile.fulfilled, (state, action) => {
        state.loading = false;
        state.findAbhaSearchResult = action.payload?.result?.list || action.payload;
        state.success = true;
        state.error = null;
      })
      .addCase(findAbhaByMobile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(requestFindAbhaOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(requestFindAbhaOtp.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(requestFindAbhaOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(verifyFindAbhaOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyFindAbhaOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetails = getAbhaUserDetailsPayload(action.payload);
        state.success = true;
        state.error = null;
      })
      .addCase(verifyFindAbhaOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetState, setFindAbhaUserDetails } = AbhaRegistration.actions;
export default AbhaRegistration.reducer;
